<template>
  <div>
    <base-navigation></base-navigation>


    <div class="campaign-form">
      <h2>Register Fundraising Campaign</h2>
      <form @submit.prevent="submitCampaign">
        <div class="form-group">
          <label for="campaignName">Campaign Name:</label>
          <input
            type="text"
            id="campaignName"
            v-model="campaign.name"
            placeholder="Enter campaign name"
            required
          />
        </div>
        <div class="form-group">
          <label for="campaignMessage">Message:</label>
          <textarea
            id="campaignMessage"
            v-model="campaign.message"
            placeholder="Enter campaign message"
            rows="5"
            required
          ></textarea>
        </div>
        <button type="submit" class="btn-submit">Submit Campaign</button>
      </form>
    </div>
  </div>
  </template>
  
  <script>
  import axios from "axios";
import router from "../../router";
  
  export default {
    name: "CampaignForm",
    data() {
      return {
        campaign: {
          name: "",
          message: "",
        },
        userId: null, // Initialize userId
      };
    },
    created() {
      // Retrieve user_id from localStorage
      const user = localStorage.getItem("user");
      console.log(JSON.parse(user).id)
      if (user) {
        this.userId = JSON.parse(user); // Parse the stored JSON if necessary
        console.log(this.userId.names)

      } else {
        alert("User not logged in. Please log in to continue.");
        // Optionally, redirect to login page:
        // this.$router.push('/login');
      }
    },
    methods: {
      async submitCampaign() {
        try {
          // Ensure userId is set
          if (!this.userId) {
            //alert("User ID is missing. Please log in again.");
            //return;
          }
  
          // Validate inputs
          if (!this.campaign.name.trim() || !this.campaign.message.trim()) {
            alert("Please fill in all fields.");
            return;
          }
  
          // Create campaign data object
          const campaignData = {
            user_id: this.userId.id,
            user_name: this.userId.names,
            name: this.campaign.name.trim(),
            message: this.campaign.message.trim(),
          };
          console.log(campaignData)
  
          // Submit data to the backend
          const response = await axios.post(
            "https://api.roberms.com/fundraise/new/campaign", // Replace with your backend API endpoint
            campaignData
          );
          console.log(response)
          router.push('/dashboard')
  
          // Handle response
        //   if (response.data.success) {
        //     alert("Campaign registered successfully!");
        //     this.campaign.name = "";
        //     this.campaign.message = "";
        //   } else {
        //     alert(response.data.message || "Failed to register the campaign.");
        //   }
        } catch (error) {
          console.error("Error submitting campaign:", error);
          alert("An error occurred while submitting the campaign.");
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .campaign-form {
    max-width: 400px;
    margin: 0 auto;
    padding: 1em;
    border: 1px solid #ccc;
    border-radius: 8px;
    background: #f9f9f9;
  }
  
  .form-group {
    margin-bottom: 1em;
  }
  
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5em;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 0.5em;
    font-size: 1em;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .btn-submit {
    width: 100%;
    padding: 0.5em;
    font-size: 1em;
    font-weight: bold;
    color: #fff;
    background: #28a745;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .btn-submit:hover {
    background: #218838;
  }
  </style>
  
